module.exports = __webpack_public_path__ + "static/semantic-placeholder-content-header-b6415c470df549baebcfab45c1a968aa.gif";